import React, { useState } from 'react';
import ViewTable from 'app/shared/view-table/view-table';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { convertDateFromServer } from 'app/shared/util/date-utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, useParams } from 'react-router-dom';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import { FinalReportOfSupervisingEngineerViewModel } from 'app/edozvola/cases/case-technical-inspection/model/case-technical-inspection.model';
import { deleteFinalReportQuery, fetchFinalReportsTableQuery } from 'app/edozvola/cases/case-technical-inspection/service/case-technical-inspection.queries';
import { getFinalReportFile } from './service/case-technical-inspection.service';
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';
import { TABLE_QUERY_KEYS } from 'app/config/constants';
import { getInvalidRowsForTable } from 'app/shared/util/validation-errors.util';
import { getCaseContext } from 'app/shared/util/context-util';
import error = toast.error;
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';
import { LOCAL_STORAGE_KEYS } from 'app/shared/util/local-storage-keys';
import { openFileInNewWindow } from 'app/shared/util/navigation-util';

const FinalReportTable = ({ setFinalReport, setReadOnly }) => {
  const { id } = useParams<{ id: string }>();
  const { sidebarItemPair } = getCaseContext();

  const [idFinalReportToDelete, setIdFinalReportToDelete] = useState();
  const [deleteModalShown, setDeleteModalShown] = useState(false);

  const invalidRowIds = getInvalidRowsForTable(TABLE_QUERY_KEYS.FINAL_REPORTS_TABLE);

  const { mutate: deleteFinalReport, isPending: deletingFinalReport } = deleteFinalReportQuery();

  const openFinalReportForm = (idFinalReport: number, readOnly: boolean) => {
    setFinalReport(idFinalReport);
    setReadOnly(readOnly);
  };

  const openDeleteDialog = idToDelete => {
    setIdFinalReportToDelete(idToDelete);
    setDeleteModalShown(true);
  };

  const removeFinalReport = () => {
    setDeleteModalShown(false);
    deleteFinalReport(idFinalReportToDelete);
  };

  const downloadFile = (idFinalReport: number, fileName: string) => {
    getFinalReportFile(idFinalReport)
      .then(data => {
        if (data) {
          openFileInNewWindow(data.url)
        }
      })
      .catch(err => showToast(error, 'Dogodila se greška prilikom preuzimanja dokumenta.'));
  };

  const renderTableRow = (value: FinalReportOfSupervisingEngineerViewModel, reportIndex: number, totalItems: number) => {
    return (
      <tr key={reportIndex} className={invalidRowIds.includes(value.idFinalReport) ? 'invalid-table-row' : ''}>
        <td>
          <div className={'column-with-multiple-data'}>
            <span>{value.finalReportType}</span>
            <span>{value.workType}</span>
          </div>
        </td>
        <td>
          <span>{value.supervisingEngineer}</span>
        </td>
        <td>{value.buildingDiaryCode}</td>
        <td>
          <span>{value.mark}</span>
        </td>
        <td>
          <span>{convertDateFromServer(value.reportDate)}</span>
        </td>

        <td>
          <div className={'actions-container'}>
            {sidebarItemPair?.canViewDocument && value.hasAttachment && (
              <TooltipWrapper message={'Pregledaj dokument'}>
                <FontAwesomeIcon
                  icon={'file'}
                  className={'icon-table'}
                  onClick={() => downloadFile(value.idFinalReport, value.finalReportType)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canView && (
              <TooltipWrapper message={'Pregledaj izvješće'}>
                <FontAwesomeIcon icon={'eye'} className={'icon-table'} onClick={() => openFinalReportForm(value.idFinalReport, true)} />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canEdit && (
              <TooltipWrapper message={'Uredi'}>
                <FontAwesomeIcon
                  icon={'pen-to-square'}
                  className={'icon-table'}
                  onClick={() => openFinalReportForm(value.idFinalReport, false)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canDelete && (
              <TooltipWrapper message={'Obriši'}>
                <FontAwesomeIcon icon={'trash-alt'} className={'icon-table'} onClick={() => openDeleteDialog(value.idFinalReport)} />
              </TooltipWrapper>
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ViewTable
        initialPaginationColumn={'finalReportType'}
        renderTableRow={renderTableRow}
        fetchDataQuery={fetchFinalReportsTableQuery}
        fetchDataProps={id}
        noDataMessage={'Nema dodanih završnih izvješća.'}
      >
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Završno izvješće', 'Vrsta radova']} width={'280px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Nadzorni inženjer']} width={'240px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Građevinski dnevnik']} width={'150px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Oznaka']} width={'100px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Datum izrade']} width={'80px'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Akcije']} width={'100px'} />
      </ViewTable>

      <Modal scrollable isOpen={deleteModalShown} size={'lg'} toggle={() => setDeleteModalShown(false)} centered>
        <ModalHeader>
          <span>Brisanje izvješća</span>
        </ModalHeader>
        <ModalBody>
          <div>Jeste li sigurni da želite obrisati podatke?</div>
        </ModalBody>
        <ModalFooter>
          <Button size={'lg'} label="Odustani" outline onClick={() => setDeleteModalShown(false)} color={'secondary'} />
          <Button size={'lg'} label="Obriši" onClick={removeFinalReport} color={'danger'} />
        </ModalFooter>
      </Modal>
    </>
  );
};

export default FinalReportTable;
